import { HttpBackend, HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IRole, IRoleList, IUpdateUser, IUser } from '@lib/interfaces';
import { IUserList } from '@lib/interfaces';

@Injectable({
    providedIn: 'root',
})
export class AccessManagementService {
    reloadAccountsList: EventEmitter<boolean> = new EventEmitter();
    private _roles: Array<IRole> = [];
    environment_url: string;
    nonInterceptorHttp: HttpClient;

    public set roles(roles: Array<IRole>) {
        this._roles = roles;
    }

    public get roles(): Array<IRole> {
        return this._roles;
    }

    constructor(private http: HttpClient) {
        this.environment_url = environment.api_url;
    }

    fetchUsers(payload: string): Observable<IUserList> {
        return this.http.get<IUserList>(`${this.environment_url}nfront/v1/admins?${payload}`);
    }

    fetchUserById(userId: string): Observable<any> {
        return this.http.get<any>(`${this.environment_url}nfront/v1/admins/${userId}`);
    }

    updateUser(userId: string, payload: IUpdateUser): Observable<any> {
        return this.http.put<IUpdateUser>(`${this.environment_url}nfront/v1/admins/${userId}`, payload);
    }

    createAgent(payload: any): Observable<any> {
        return this.http.post<any>(`${this.environment_url}nfront/v1/admins/agents`, payload);
    }
}
